'use strict';

var app = require('angular').module('olsalgApp');

app.controller('MainController', require('./main'));
app.controller('PreQuizController', require('./prequiz'));
app.controller('GameController', require('./game'));
app.controller('EndGameController', require('./endGame'));
app.controller('HighscoreController', require('./highscore'));
app.controller('StatsController', require('./stats'));
app.controller('CompetitionController', require('./competition'));
